import { TextAreaInput, Switch } from "@jugl-web/ui-kit";
import { useFormFieldsValidators, useTranslations } from "@jugl-web/utils";
import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";
import { EmailSettingsFormValues } from "../EmailSettingsTab/types";

export const AIMessageDisclaimerSection: React.FC = () => {
  const { t } = useTranslations();
  const { requiredValidator } = useFormFieldsValidators();
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext<EmailSettingsFormValues>();
  const isEnabled = useWatch({
    control,
    name: "ai_msg_disclaimer_enabled",
  });

  return (
    <CRMInfoSection
      title={
        <span className="flex items-center gap-2.5">
          <Controller
            control={control}
            name="ai_msg_disclaimer_enabled"
            render={({ field: { value, onChange } }) => (
              <Switch
                isChecked={value}
                onChange={(checked) => {
                  onChange(checked);
                  if (!checked) {
                    clearErrors("ai_msg_disclaimer");
                  }
                }}
              />
            )}
          />
          {t({
            id: "client-support-page.ai-message-disclaimer",
            defaultMessage: "AI message Disclaimer",
          })}
        </span>
      }
      subtitle={t({
        id: "client-support-page.ai-message-disclaimer-description",
        defaultMessage:
          "Indicated note will be shown at the bottom of all replies sent by AI Agent",
      })}
    >
      <Controller
        control={control}
        name="ai_msg_disclaimer"
        rules={{
          validate: (value, formValues) => {
            if (!formValues.ai_msg_disclaimer_enabled) {
              return true;
            }

            const { validate } = requiredValidator();

            if (typeof validate === "function") {
              return validate(value, formValues);
            }

            return true;
          },
        }}
        render={({ field: { value, onChange, ref } }) => (
          <TextAreaInput
            classNames={{
              wrapperClassName: "w-full",
            }}
            ref={ref}
            value={value}
            onChange={(event) => onChange(event.target.value.trimStart())}
            isDisabled={!isEnabled}
            isInvalid={!!errors.ai_msg_disclaimer}
            errorMessage={errors.ai_msg_disclaimer?.message}
            placeholder={t({
              id: "client-support-page.ai-message-disclaimer-placeholder",
              defaultMessage: "This message was composed by AI",
            })}
          />
        )}
      />
    </CRMInfoSection>
  );
};
